module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h3', [_vm._v("Site Information - Getting Started")])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n          See below links for guides and information to help you get started.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://docs.google.com/document/d/1wHfTm_Pu-sYCWYwFP1d7Htt4hlPyOCbAsSY6mFeoeU8/edit?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("WyoTrack News")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://docs.google.com/document/d/1UeQ2Fdu6gBZJpVAMaCBt7ih2pcDAMpkcjVVYJvk6wdA/edit?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("User Manual")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://docs.google.com/document/d/1mV4Pk9G6zp1DQfa-fqfyaY6oj0M5pKPXdDN3xwDoPL4/edit",
      "target": "_blank"
    }
  }, [_vm._v("GIS Manual")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://drive.google.com/file/d/1ghp2d3_oaKg_DvJQxufXlXWvIkKQSJOl/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("CR Risk Layer Map Guide")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("\n          GIS Resources:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://drive.google.com/a/gannettpeaktech.com/file/d/1Ta9pJr1eDM9xMzZaCPRUzK5tjm8LI-ha/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("GIS XML Template")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://drive.google.com/a/gannettpeaktech.com/file/d/15PpZcVPNFStuxxcQE_v9BMjmtmuN_UfZ/view?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("GIS Template Zip")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91eadf1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HelpInfo.vue
// module id = 975
// module chunks = 1